import { render, staticRenderFns } from "./PaySlip.vue?vue&type=template&id=5ade6528&scoped=true&"
import script from "./PaySlip.vue?vue&type=script&lang=js&"
export * from "./PaySlip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ade6528",
  null
  
)

export default component.exports